<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <section>
      <page-header :headerName="'Funcionalidades Extras'" :showBtn="false" :btnName="''" :btnRoute="''"
                   :css="'container-fluid'"/>

      <div class="page-content">
        <div class="container-fluid">
          <div class="row">
            <!-- Loading from page -->
            <full-loading v-if="loadingList"/>

            <!-- Filters -->
            <div class="col-xs-12 col-sm-12 col-md-12">
              <div v-if="!loadingList" class="col-xs-12 col-sm-12 col-md-12 default-box filters">
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <div class="col-xs-12 col-sm-6 col-md-4">
                    <div class="form-group">
                      <label for="featureType">Funcionalidades</label>
                      <select v-model="dataSearch.featureType" id="featureType" name="featureType" required>
                        <option value="">Selecione</option>
                        <option value="0">Todos</option>
                        <option v-for="(s, index) in listFilter" v-bind:value="s.featureType">
                          {{ s.name }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="col-xs-12 col-sm-6 col-md-4">
                    <div class="form-group">
                      <label for="id">ID da empresa</label>
                      <input v-model="dataSearch.id" type="text" class="form-control" id="id" name="id"/>
                    </div>
                  </div>

                  <div class="col-xs-12 col-sm-6 col-md-4">
                    <div class="form-group">
                      <label>Nome da empresa</label>
                      <input v-model="dataSearch.name" type="text" class="form-control" name="name" id="name" required/>
                    </div>
                  </div>
                </div>

                <div class="col-xs-12 col-sm-12 col-md-12">
                  <button v-on:click="getList()">Pesquisar</button>
                </div>
              </div>
            </div>

            <!-- No Result -->
            <div v-if="
                !loadingList &&
                dataLog !== '' &&
                !dataLog.length &&
                !failRequest
              " class="col-xs-12 col-sm-12 col-md-12">
              <div class="
                  col-xs-12 col-sm-12 col-md-12
                  default-box
                  content-default
                ">
                <p>Sem resultado na pesquisa.</p>
              </div>
            </div>

            <!-- Fail Request -->
            <div v-if="!loadingList && failRequest" class="col-xs-12 col-sm-12 col-md-12">
              <div class="
                  col-xs-12 col-sm-12 col-md-12
                  default-box
                  content-default
                ">
                <p>Falha na requisição.</p>
              </div>
            </div>

            <!-- Table -->
            <div v-if="!loadingList && dataLog.length" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box orderBy">
                <div class="portlet-title">
                  <div class="caption">
                  <span class="caption-subject font-blue bold uppercase">Quantidade de resultado filtrados
                    ({{ dataLog.length }})
                  </span>
                  </div>

                  <div class="orderBy">
                    <label>
                      Ordem por:
                      <select v-model="orderByValue">
                        <option value="name">Nome</option>
                        <option value="email">Email</option>
                        <option value="featureType">Funcionalidade</option>
                        <option value="price">Valor</option>
                      </select>
                    </label>
                  </div>
                </div>

                <div class="portlet-body contate-table offset-top-20">
                  <div class="table-scrollable table-scrollable-borderless">
                    <table class="table table-hover table-light table-icon">
                      <thead>
                      <tr>
                        <th>Nome</th>
                        <th>Email</th>
                        <th>Funcionalidade</th>
                        <th>Contratado em:</th>
                        <th>Assinado por:</th>
                        <th>Valor</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="c in orderBy(dataLog, orderByValue)">
                        <td>
                          <a v-bind:href="
                                '/detalhes-da-empresa/' +
                                c.companyId +
                                '/' +
                                c.contextCode
                              " target="_blank" class="link">{{ c.name }}</a>
                        </td>
                        <td>{{ c.email }}</td>
                        <td>{{ c.featureType }}</td>
                        <td>{{ c.value | formatDate }}</td>
                        <td>{{ c.userName }}</td>
                        <td>R{{ c.price | currency }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import pageHeader from "../../components/default/pageHeader.vue";
import ptBR from "vuejs-datepicker/dist/locale/translations/pt-BR";
import datepicker from "vuejs-datepicker";
import swal from "sweetalert";
import moment from "moment";

import {
  GET_LIST_FEATURES,
  CHANGE_DADE_FEATURE
} from "../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../requestConfig";

export default {
  name: "funcionalidades-extras",
  components: {
    datepicker,
    topMenu,
    pageHeader,
    fullLoading,
  },
  data() {
    return {
      callCheckRequest: "",
      ptBR: ptBR,
      failRequest: false,
      loadingList: false,
      loading: false,
      listFilter: [],
      dataLog: "",
      orderByValue: "name",
      dataSearch: {
        name: "",
        featureType: "",
        id: "",
      },
    };
  },
  methods: {
    getList() {
      this.loadingList = true;
      let url = GET_LIST_FEATURES;
      url += "?p=1";

      if (this.dataSearch.featureType) {
        url += "&type=" + this.dataSearch.featureType;
      }

      if (this.dataSearch.id) {
        url += "&id=" + this.dataSearch.id;
      }

      if (this.dataSearch.name) {
        url += "&name=" + this.dataSearch.name;
      }

      UTIL_SERVICE.console("URL SEARCH:", url);
      REQUEST_SERVICE.get(url).then((response) => {
        UTIL_SERVICE.console("RESULT GET_LIST_FEATURES:", response.data);

        this.dataLog = response.data;

        this.loadingList = false;
        this.failRequest = false;
      })
        .catch((reason) => {
          this.loadingList = false;
          this.failRequest = true;
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    getDadeFeature() {
      this.loadingList = true;
      this.failRequest = false;

      let url = CHANGE_DADE_FEATURE;
      UTIL_SERVICE.console("URL SEARCH:", url);
      REQUEST_SERVICE.requestContext("GET", url)
        .then((response) => {
          UTIL_SERVICE.console("RESULT CHANGE_DADE_FEATURE:", response.data);

          this.listFilter = response.data;

          this.loadingList = false;
        })
        .catch((reason) => {
          this.loadinDadeList = false;
          this.failRequest = true;
        });
    },
  },
  beforeMount() {
    this.getList();
    this.getDadeFeature();
  },
};
</script>

<style lang="scss">
.btn-all-excel {
  cursor: pointer;
  margin-left: 5px;
  display: inline-block;
  padding: 8px 10px;
  background-color: #00a651;
  color: #fff;
  margin-bottom: 20px;
  border-radius: 4px !important;
  float: right;
  font-weight: 600;
  margin-top: 0;
  border: none;

  i {
    margin-left: 5px;
  }

  &:hover {
    color: #fff;
    background-color: #008d45;
  }
}

.input-with-date {
  width: 100%;

  input {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/reports/extraFeatures.vue